/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamTypesQueryResponse,
  GetApiV1ExamTypes401,
  GetApiV1ExamTypes500,
} from "../../types/examEvaluationController/GetApiV1ExamExamTypes.ts";

function getGetApiV1ExamExamTypesUrl() {
  const res = { method: "GET", url: `/api/v1/exam/exam-types` as const };
  return res;
}

/**
 * @description Retorna todos os tipos de prova disponíveis para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Listar tipos de prova para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-types}
 */
export async function getApiV1ExamExamTypes(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamTypesQueryResponse,
    ResponseErrorConfig<GetApiV1ExamTypes401 | GetApiV1ExamTypes500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamTypesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
